import ApiCaller from 'actions/ApiCaller';
import baseAjaxConfig from 'actions/BaseAjaxConfig';
export var GetPanCardStatus;
(function (GetPanCardStatus) {
    GetPanCardStatus["REQUEST"] = "GET_PAN_CARD_STATUS_REQUEST";
    GetPanCardStatus["SUCCESS"] = "GET_PAN_CARD_STATUS_SUCCESS";
    GetPanCardStatus["ERROR"] = "GET_PAN_CARD_STATUS_ERROR";
})(GetPanCardStatus || (GetPanCardStatus = {}));
export function getPancardStatusAction() {
    return (dispatch) => {
        dispatch({
            type: GetPanCardStatus.REQUEST
        });
        return ApiCaller.get(Object.assign({}, baseAjaxConfig, {
            pathname: `/api/1/user/pan/status`,
            acceptErrors: true,
            action: GetPanCardStatus.REQUEST
        })).then(json => dispatch({
            type: GetPanCardStatus.SUCCESS,
            data: json['RESPONSE']
        }), err => {
            if (err.STATUS_CODE === 404) {
                return dispatch({
                    type: GetPanCardStatus.SUCCESS,
                    data: {
                        status: 'Not_available'
                    }
                });
            }
            return Promise.reject(err['RESPONSE'] || err);
        });
    };
}
export var UploadPanCard;
(function (UploadPanCard) {
    UploadPanCard["REQUEST"] = "UPLOAD_PAN_CARD_REQUEST";
    UploadPanCard["SUCCESS"] = "UPLOAD_PAN_CARD_SUCCESS";
    UploadPanCard["ERROR"] = "UPLOAD_PAN_CARD_ERROR";
})(UploadPanCard || (UploadPanCard = {}));
export function uploadPancardAction(payload) {
    return (dispatch) => {
        dispatch({
            type: UploadPanCard.REQUEST
        });
        let headers = Object.assign({}, baseAjaxConfig.headers);
        delete headers['Content-Type'];
        return ApiCaller.post(Object.assign({}, baseAjaxConfig, {
            pathname: '/api/1/user/pan/upload',
            multipart: true,
            headers,
            action: UploadPanCard.REQUEST
        }), payload).then(json => dispatch({
            type: UploadPanCard.SUCCESS,
            data: json['RESPONSE']
        }), err => {
            dispatch({
                type: UploadPanCard.ERROR
            });
            return Promise.reject(err);
        });
    };
}
